const sizeLetter = {
	small: '1vw',
	normals: '1.2vw',
	normal: '1.4vw',
	medium: '1.6vw',
	big: '1.8vw',
	extraBig: '2.0vw',
	dots: '2.2vw',
	cellSmall: '1.4vh',
	cellNormal: '1.8vh',
	cellMedium: '2vh',
	cellBig: '2.2vh',
	cellExtraBig: '2.4vh',
};

export default sizeLetter;
